import { SlideWaveBackground } from "@/components/investors/slides/SlideWaveBackground";

export function V3CloseSlide({ isActive: _ }: { isActive: boolean }) {
  return (
    <div className="relative flex flex-col justify-center items-center h-full text-center">
      <SlideWaveBackground />
      <div className="relative z-10">
        <h2 className="text-[48px] font-light tracking-tight leading-[1.05] font-[family-name:var(--font-heading)] mb-6">
          The AI-Native<br />Service Compounder
        </h2>
        <p className="text-[18px] text-[var(--color-fg-secondary)] leading-relaxed font-light mb-10">
          Back-office today. Industry tomorrow.
        </p>
        <div className="flex items-center justify-center gap-3 text-[13px] font-[family-name:var(--font-mono)] text-[var(--color-fg-secondary)]">
          <span className="font-medium text-[var(--color-fg)]">Ben Zhang</span>
          <span className="text-[var(--color-border)]">·</span>
          <a href="mailto:ben@cosx.co" className="hover:text-[var(--color-accent)] transition-colors">ben@cosx.co</a>
          <span className="text-[var(--color-border)]">·</span>
          <a href="https://cosx.co" target="_blank" rel="noopener noreferrer" className="text-[var(--color-accent)] hover:opacity-80 transition-opacity">cosx.co</a>
        </div>
      </div>
    </div>
  );
}
